import {
  CHECKBOX_TYPE,
  DROPDOWN_TYPE,
  RADIO_TYPE,
  TEXT_TYPE,
  FIELD_TYPE_LABELS,
  FIELD_PREVIEW_TEXT
} from './constants';

class Field {
  constructor(element, pillFactory, fieldTierVisibilityFactory) {
    this.element = element;
    this.pillFactory = pillFactory;
    this.fieldTierVisibilityFactory = fieldTierVisibilityFactory;
  }

  get htmlElement() {
    return this.element;
  }

  set name(name) {
    this._name = name;

    this.element.querySelectorAll('span[data-role="fieldLabel"]').forEach(
      (e) => e.innerHTML = name
    );
    this.element.querySelectorAll('input[data-role="fieldLabel"]').forEach(
      (e) => e.value = name
    );
  }

  set type(type) {
    this._type = type;

    this.element.querySelectorAll('span[data-role="fieldType"]').forEach(
      (e) => e.innerHTML = FIELD_TYPE_LABELS[type]
    );
    this.element.querySelectorAll('input[data-role="fieldType"]').forEach(
      (e) => e.value = type
    );

    if (FIELD_PREVIEW_TEXT[type]) {
      this.element.querySelectorAll('input[data-role="preview"]').forEach(
        (e) => e.value = FIELD_PREVIEW_TEXT[type]
      )
    }
  }

  set ordinal(ordinal) {
    this._ordinal = ordinal;

    this.element.querySelectorAll('input[data-role="fieldOrdinal"]').forEach(
      (e) => e.value = ordinal
    );
  }

  set collection(collection) {
    this._collection = collection;

    const dropdownOptionsContainer = this.element.querySelector(
      '[data-role="fieldItemContainer"]'
    );

    collection.forEach(
      (itemLabel) => {
        const newOption = this.pillFactory.make(
          itemLabel, { labelOnly: false, ordinal: this._ordinal }
        );

        dropdownOptionsContainer.appendChild(newOption);
      }
    );
  }

  set required(required) {
    this._required = required;

    this.element.querySelector('[data-role="fieldRequired"]').value = required;

    if (required) {
      this.element.querySelector('span[data-role="fieldRequired"]').classList.remove('d-none');
    } else {
      this.element.querySelector('span[data-role="fieldRequired"]').classList.add('d-none');
    }
  }

  enableField() {
    switch (this._type) {
      case CHECKBOX_TYPE:
        this.element.querySelector('[data-role="textPreview"]').classList.add('d-none');
        this.element.querySelector('[data-role="checkboxPreview"]').classList.remove('d-none');
        break;
      case DROPDOWN_TYPE:
        this.element.querySelector('[data-role="fieldItemContainer"]').classList.remove('d-none');
        this.element.querySelector('[data-role="textPreview"]').classList.add('d-none');
        this.element.querySelector('[data-role="dropdownPreview"]').classList.remove('d-none');
        break;
      case RADIO_TYPE:
        this.element.querySelector('[data-role="textPreview"]').classList.add('d-none');
        this.element.querySelector('[data-role="radioPreview"]').classList.remove('d-none');

        const radioContainer = this.element.querySelector('[data-role="radioItemContainer"]');

        this._collection.forEach((itemLabel) => {
          const wrapper = document.createElement('div');
          wrapper.classList.add('form-check', 'd-flex', 'align-items-center', 'me-3');
          wrapper.innerHTML = `
              <input class="form-check-input radio_buttons optional me-2"
                name="membership[fields_attributes][${this._ordinal}][collection][]"
                type="radio"
                disabled
                value="${itemLabel}" />
              <label class="form-check-label collection_radio_buttons">
                ${itemLabel}
              </label>
          `;

          radioContainer.appendChild(wrapper);
        });
        break;
      case TEXT_TYPE:
        break;
    }
  }

  showTierVisibility() {
    this.element.querySelector('[data-role="tierVisibility"]').classList.remove('d-none');
  }

  hideTierVisibility() {
    this.element.querySelector('[data-role="tierVisibility"]').classList.add('d-none');
  }


  addTierVisibility(tierInstance) {
    const initialTierName = tierInstance.name || 'New Tier';
    const tierVisibilitySection = this.element.querySelector('[data-role="tierVisibility"]');
    const existingTier = tierVisibilitySection.querySelector(`[data-tier-ordinal="${tierInstance.ordinal}"]`);
    const visibilityContainer = tierVisibilitySection.querySelector('[data-role="visibilityContainer"]');

    if (existingTier) {
      return;
    }

    const visibilityElement = this.fieldTierVisibilityFactory.make({
      name: initialTierName,
      fieldOrdinal: this._ordinal,
      tierInstance
    });

    visibilityContainer.appendChild(visibilityElement.htmlElement);
  }
}

export { Field };